/***
*
*   PROGRESS STEPS
*   Steps are used to indicate the current point in a
*   multi-stage process, such as filling in a long form
*
*   PROPS
*   items: array of objects containing keys: name, url
*   and completed (bool)
*
**********/

import React from 'react';
import { Link } from 'components/lib'
import Style from './steps.module.scss';

export function ProgressSteps(props){

  return(
    <ol className={ Style.steps }>
      { props.items &&
        Object.keys(props.items).map(item => {

          item = props.items[item];

          return (
            <li 
              key={ item.name } 
              className={ item.completed ? Style.complete : undefined } 
              style={{ 
                marginRight: props.marginRight ? props.marginRight : undefined, 
                boxShadow: props.shadow ? '-1px 0px 3px' : undefined 
              }}
            >
              <Link url={ item.url } text={ item.name } completed={ item.completed } iconLinkLeft={ item.iconLeft } iconLinkRight={ item.iconRight } locked={ props.locked || item.locked ? true : null } click={ item.click ? item.click : null }/>
            </li>
          );
      })}
    </ol>
  )
}
